export const SORTING_OPTIONS = [
  {
    value: 'productName_asc',
    label: 'Product Name A-Z',
  },
  {
    value: 'productName_desc',
    label: 'Product Name Z-A',
  },
  {
    value: 'productLowPrice.price_desc',
    label: 'Price: High to Low',
  },
  {
    value: 'productLowPrice.price_asc',
    label: 'Price: Low to High',
  },
  {
    value: 'productCreatedDate_desc',
    label: 'Date Added Newest First',
  },
  {
    value: 'productCreatedDate_asc',
    label: 'Date Added Oldest First',
  },
  {
    value: 'isFeatured_desc',
    label: 'Featured First',
  },
];
